import { render, staticRenderFns } from "./FormWidget.vue?vue&type=template&id=6022a820&"
import script from "./FormWidget.vue?vue&type=script&lang=js&"
export * from "./FormWidget.vue?vue&type=script&lang=js&"
import style0 from "./FormWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports